var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailMain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.288 11.648l3.824-3.264 3.952-3.04c.24-.192.592.064.48.352l-1.84 5.024-6.416.928z",
    fill: "#4C6AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.264 13.36l3.44-2.656-7.6-7.008-2.944 8.048 6.416 1.76c.24.064.496.016.688-.144z",
    fill: "#4C6AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.088 3.696L2.16 11.744l-1.152 3.168A3.55 3.55 0 010 12.432V3.568c0-.592.144-1.136.4-1.632l4.688 1.76z",
    fill: "#4C6AFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.088 3.696L2.16 11.744l1.312.352 1.616-8.4zM12.688 10.704l-1.904-2.848-.64.496 2.544 2.352z",
    fill: "#3D55CC"
  })));
}
export default __webpack_public_path__ + "static/mail_main.968c85d6.svg";
export { SvgMailMain as ReactComponent };